import { memo, useEffect, useState, useCallback } from "react"
import { Toast, Upload } from "dingtalk-design-mobile"
import dd from "@/utils/dd.config"
import './Upload.less'

const UploadMain = ({
  fileType = 1,
  max = 9,
  value,
  extra = '',
  onChange,
  ...rest
}) => {
  const [fileList, setFileList] = useState([])
  const [upFileList, setUpFileList] = useState([])

  useEffect(() => {
    if (value)
      setFileList(value)
  }, [value])

  useEffect(() => {
    if (!value && onChange)
      onChange(fileList)
  }, [onChange, fileList, value])

  const changeValue = useCallback(fn => {
    if (value) {
      onChange && onChange(fn(value))
    } else {
      setFileList(list => {
        const fileList = fn(list)
        return fileList
      })
    }
  } , [value, onChange])

  const handleChange = useCallback(({ fileList }) => {
    Toast.loading({
      content: '加载中...',
      showType: 'normal',
      duration: 0
    })
    const failList = []
    const successList = []
    const maxSizeList = []
    fileList.forEach(item => {
      const { status } = item
      if (!status) {
        maxSizeList.push(item)
        return
      }
      if (status !== 'uploading') {
        if (status === 'done') {
          const { result, success } = item.response || {}
          if (success && result) {
            successList.push(result)
          } else {
            failList.push(item)
          }
          return
        }
        failList.push(item)
      }
    })
    if (failList.length + successList.length + maxSizeList.length === fileList.length) {
      setUpFileList([])
      if (maxSizeList.length) {
        Toast.fail({
          content: '图片不能超过10M',
          duration: 2
        })
        return
      }
      if (failList.length) {
        Toast.fail({
          content: failList.length !== fileList.length ? '部分图片上传失败' : '上传失败！',
          duration: 2
        })
        return
      }
      changeValue(list => [ ...list, ...successList ])
      Toast.hide()
    } else {
      setUpFileList(fileList)
    }

  }, [changeValue])

  const handleRemove = useCallback((e, index) => {
    e.stopPropagation()
    changeValue(list => list.filter((_item, idx) => index !== idx))
  }, [changeValue])

  const handleBefore = useCallback((file) => {
    // 图片上传最大支持10m
    return !(file && file.size > 10000000)
  }, [fileList])
  
  return <div>
    {
     !!extra && <div>{ extra }</div>
    }
    <div className="com-upload">
      {
        fileList.map((item, index) =>
          <div key={index} className="com-upload-img-box">
            <img
              className="com-upload-img"
              alt="加载中"
              src={item.filePath}
              onClick={() => dd.previewImage(fileList.map(item => item.filePath), index)}
            />
            <img
              className="com-upload-remove"
              onClick={e => handleRemove(e, index)}
              alt="加载中"
              src="http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/remove.png"
            />
          </div>
        )
      }
      {max > fileList.length && <div className="com-upload-render">
        <img
          className="com-upload-render-img"
          alt="加载中"
          src="http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/add.png"
        />
        <Upload
          { ...rest }
          accept="image/*"
          type="form-upload"
          action="/work/file/uploadOss"
          data={{ fileType, token: localStorage.getItem('TOKEN') }}
          onChange={handleChange}
          name="file"
          className="com-upload-dd"
          style={{ zIndex: -1, ...rest?.style }}
          isImageUrl={false}
          beforeUpload={handleBefore}
          fileList={upFileList}
          maxCount={max - fileList.length}
        />
      </div>}
    </div>
  </div>
}

export default memo(UploadMain)
